// 9fbef606107a605d69c0edbcd8029e5d
import { STORE_DETAIL_ACTION_PATTERN } from '@tcp/core/src/constants/reducer.constants';

export default {
  SET_CURRENT_STORE: `${STORE_DETAIL_ACTION_PATTERN}SET_CURRENT_STORE`,
  GET_CURRENT_STORE: `${STORE_DETAIL_ACTION_PATTERN}GET_CURRENT_STORE`,
  SET_SUGGESTED_STORE: `${STORE_DETAIL_ACTION_PATTERN}SET_SUGGESTED_STORE`,
  GET_SUGGESTED_STORE: `${STORE_DETAIL_ACTION_PATTERN}GET_SUGGESTED_STORE`,
  SET_MODULEX_CONTENT: `${STORE_DETAIL_ACTION_PATTERN}SET_MODULEX_CONTENT`,
  GET_MODULEX_CONTENT: `${STORE_DETAIL_ACTION_PATTERN}GET_MODULEX_CONTENT`,
  SET_LOADING_STORE_DETAIL_STATUS: `${STORE_DETAIL_ACTION_PATTERN}SET_LOADING_STORE_DETAIL_STATUS`,
  OTHER_STORES_COUNT: 5,
  SET_SUGGESTED_STORE_LOADING: `${STORE_DETAIL_ACTION_PATTERN}SET_SUGGESTED_STORE_LOADING`,
  FETCH_PRODUCTS_REQUEST: `${STORE_DETAIL_ACTION_PATTERN}FETCH_PRODUCTS_REQUEST`,
  FETCH_PRODUCTS_SUCCESS: `${STORE_DETAIL_ACTION_PATTERN}FETCH_PRODUCTS_SUCCESS`,
  FETCH_PRODUCTS_FAILURE: `${STORE_DETAIL_ACTION_PATTERN}FETCH_PRODUCTS_FAILURE`,
  RESET_STORE_SPECIAL_PRODUCTS: `${STORE_DETAIL_ACTION_PATTERN}RESET_STORE_SPECIAL_PRODUCTS`,
};
